<template>
  <div class="pb-4">
    <!-- Main Div -->
    <ConfirmationModal
      modalId="collectionWeekAlert"
      triggerEventName="collectionWeekAlert"
    />
    <div
      v-show="
        this.isServiceSelected == true && this.hideCollectionWeek == false
      "
      class="row"
    >
      <div class="col-12">
        <!-- <select-waste-type /> -->
        <h6 class="font-weight-bold">{{ dateHeader }}</h6>
        <div class="row">
          <div class="col-12">
            <div class="row no-gutters">
              <div class="col-12" v-html="dateSubheader"></div>
            </div>
            <div class="row no-gutters mb-3">
              <div class="col-12 col-lg-8">
                <!-- <code>--date-picker--</code> -->
                <resident-date-picker
                  v-bind:periodType="this.periodType"
                  v-bind:dateFilter="this.dateFilter"
                  v-bind:selectionOptions="this.selectionOptions"
                  v-bind:attributes="attributes"
                  @periodSelected="selectPeriod"
                  ref="residentDatePicker"
                  data-toggle="tooltip"
                  :title="toolTipMessage"
                />
              </div>
            </div>
            <div class="row no-gutters">
              <div class="col-12" v-if="selectedServiceDescriptor != null">
                <h6
                  class="font-weight-bold mb-1"
                  v-html="selectedServiceDeliveryMessage"
                ></h6>
                <p v-html="TEXTS.renderNonAsset(selectedServiceDescriptor)"></p>
              </div>
            </div>
          </div>
        </div>
        <div v-if="isPreparationNoteDisplayed" class="row d-lg">
          <div class="col-12">
            <p>
              <span class="font-weight-bold text-tru-orange">Note: </span>
              <span v-html="preparationNote" />
            </p>
          </div>
        </div>
        <div v-if="pickupDate != null" class="row d-lg">
          <div class="col-12">
            <h6
              class="font-weight-bold mb-1"
              v-html="pickupMessage"
            ></h6>
            <p>
              <strong class="p-1 rounded" style="background-color: #ffd2d2;">{{ pickupDate }}</strong>
            </p>
            <!-- <p>Mon, Apr 12 2019</p> -->
          </div>
        </div>
        <div v-if="dateNote != null" class="row d-lg">
          <div class="col-12">
            <p>{{ dateNote }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Summary Div -->
    <div
      v-show="this.isServiceSelected == true && this.hideCollectionWeek == true"
      class="row"
    >
      <div class="col-12">
        <!-- <select-waste-type /> -->
        <h6 class="font-weight-bold">{{ dateHeader }}</h6>
        <div class="row">
          <div class="col-lg-12">
            <div class="row no-gutters">
              <div class="col-12">
                <p v-html="dateSubheader"></p>
              </div>
            </div>
          </div>
        </div>
        <div v-if="dateNote != null" class="row d-lg">
          <div class="col-lg-12">
            <p>{{ dateNote }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- 
        -- Seemingly Useless
        <div class="row d-none d-lg-block pb-4">
            <div class="col-lg-12">
                <p>
                    <span class="font-weight-bold text--orange">Note: </span>
                    Your waste will be collected between Monday to Friday of your chosen week. Please place your waste out for collection on Sunday <span>(Oct 6 2019)</span> before your collection week.
                </p>
            </div>
        </div>
        
        <div v-if="this.is_generate_pickup_date == 1" class="row d-none d-lg-block">
            <div class="col-lg-12">
                <h6 class="font-weight-bold mb-1">Pickup Date</h6>
                <p>Mon, Apr 12 2019</p>
            </div>
        </div> -->
  </div>
</template>

<script>
import ResidentDatePicker from "./ResidentDatePicker";
import DateFormattable from "../../../../common/utils/DateFormattable";
import DateChecker from "../../../../common/utils/DateChecker";
import SelectedWasteSummary from "../../../../common/utils/SelectedWasteSummary";
import Service from "../../../../common/utils/Service";
import DateNoTz from "../../../../common/utils/DateNoTz";
import helper from "../../../../helper";
import Texts from "../../../../common/utils/Texts";
import ConfirmationModal from "../../../../common/components/ConfirmationModal";
import BookingDatesMixin from "../../../../common/mixins/BookingDatesMixin"

export default {
  mixins: [BookingDatesMixin],
  components: {
    ResidentDatePicker,
    ConfirmationModal,
  },
  data() {
    return {
      isServiceSelected: false,
      selectedServiceId: null,
      selectedPeriod: null,
      cachedWasteStreamFilters: null,
      toolTipMessage: "",
      hasActiveMultipleServiceSelectedBookingPeriod: false,
      filterCache: "",
      threshold: null,
      attributes: []
    };
  },
  computed: {
    TEXTS: () => Texts,
    bookingState: function () {
      return this.$store.getters.GET_BOOKING_STATE;
    },
    serverDate: function () {
      var serverDate = new DateFormattable(
        this.$store.getters.GET_SERVER_DATE.payload
      );
      return serverDate;
    },
    serverDateString: function () {
      return this.$store.getters.GET_SERVER_DATE.payload;
    },
    selectedService: function () {
      var selectedService = this.$store.getters.GET_BOOKING_STATE
        .selectedService;
      this.isServiceSelected =
        (selectedService && selectedService.service_setting_id) != null;
      return this.isServiceSelected ? selectedService : null;
    },
    selectedServiceName: function () {
      var selectedService = this.$store.getters.GET_BOOKING_STATE
        .selectedService;
      this.isServiceSelected =
        (selectedService && selectedService.service_setting_id) != null;
      return this.isServiceSelected ? selectedService.service_name : null;
    },
    selectedServiceWording() {
      if (this.selectedService) {
        return this.bookingState.selectedService.wording;
      }

      return null
    },
    selectedServiceNameCondensed: function () {
      if (this.selectedServiceName) {
        let condensedName = this.selectedServiceName
          .split(" ")
          .join("")
          .toLowerCase();
        if (condensedName.indexOf("skipbin") > -1) {
          return `skipbin`;
        }
      }
    },
    selectedServiceGroupName() {
      var selectedServiceGroup = this.$store.getters.GET_BOOKING_STATE
        .selectedServiceGroup;
      return selectedServiceGroup ? selectedServiceGroup.group_name : null;
    },
    wasteSummary: function () {
      var selectedWasteStreams = this.$store.getters.GET_BOOKING_STATE
        .selectedBookingProducts;
      if (selectedWasteStreams.some((f) => f.invalid)) {
        selectedWasteStreams = [];
      }

      return new SelectedWasteSummary(selectedWasteStreams);
    },
    availableBookingDatesOfAddress: function () {
      return this.$store.getters.GET_AVAILABLE_BOOKING_DATES_OF_ADDRESS.list;
    },
    entitlementSummary: function () {
      return this.$store.getters.GET_BOOKING_STATE.entitlementSummary;
    },
    periodType: function () {
      return this.selectedService ? this.selectedService.date_selection : "";
    },
    is_preparation_note: function () {
      return this.selectedService
        ? this.selectedService.is_preparation_note
        : 0;
    },
    is_generate_pickup_date: function () {
      return this.selectedService
        ? this.selectedService.is_generate_pickup_date
        : 0;
    },

    periodTypeDescriptor: function () {
      switch (this.periodType) {
        case "weekly":
          return "Week";
        case "predefined_week":
          return "Week";
        case "daily":
          return "Day";
        case "predefined_day":
          return "Day";
        case "daily_with_default":
          return "Day";
        default:
          return null;
      }
    },
    dateHeader: function () {
      if (this.selectedService) {
        return this.selectedService.date_header;
      }
    },
    dateSubheader() {
      /*
          Stry: [HC-02] Display pre-selected date at the end of date instruction
          Date: 2021-02-01
          Auth: Franco Mapua
          Desc: Making the dateSubheader dynamic
      */
      var selectedPeriod = this.$refs.residentDatePicker
        ? this.$refs.residentDatePicker.selectedPeriod
        : null;
      selectedPeriod =
        selectedPeriod &&
        typeof selectedPeriod == "object" &&
        selectedPeriod.start
          ? selectedPeriod.start
          : selectedPeriod;
      selectedPeriod = selectedPeriod
        ? new DateNoTz(selectedPeriod).formatDayDdMonYyyy()
        : "";

      if (
        this.selectedService &&
        this.selectedService.date_selection_instruction
      ) {
        var dateSubheaderTemplate = this.selectedService
          .date_selection_instruction;
        if (dateSubheaderTemplate.indexOf("collectionDate") > -1) {
          var stringArr = dateSubheaderTemplate.split("collectionDate");
          dateSubheaderTemplate = stringArr[0] + selectedPeriod + stringArr[1];
        }
        return dateSubheaderTemplate;
      } else {
        let renderSpecifier = `default`;
        if (this.selectedServiceGroupName) {
          let serviceGroupName = this.selectedServiceGroupName
            .split(" ")
            .join("")
            .toLowerCase();
          if (serviceGroupName.indexOf("bulkbin") > -1)
            renderSpecifier = `bulkbin`;
          else if (serviceGroupName.indexOf("mattress") > -1)
            renderSpecifier = `mattress`;
          else if (serviceGroupName.indexOf("whitegoods") > -1)
            renderSpecifier = `whitegoods`;
        }
        return Texts.render(`COLLECTION_WEEK_SUBHEADER`, renderSpecifier);
      }
    },
    selectedServiceDescriptor: function () {
      var formattingFunction =
        helper.getPortalName() === `kalamunda`
          ? `formatFullDayDdMonYyyy`
          : `formatDayDdMonYyyy`;
      if (!this.selectedPeriod) {
        return null;
      } else if (
        this.periodType == "weekly" ||
        this.periodType == "predefined_week"
      ) {
        return (
          new DateNoTz(this.selectedPeriod.start)[formattingFunction]() +
          " - " +
          new DateNoTz(this.selectedPeriod.end)[formattingFunction]()
        );
      } else if (
        this.periodType == "daily" ||
        this.periodType == "predefined_day" ||
        this.periodType == "daily_with_default"
      ) {
        return new DateNoTz(this.selectedPeriod)[formattingFunction]();
      }
    },
    isPreparationNoteDisplayed() {
      return this.selectedService && this.selectedPeriod
        ? this.selectedService.is_preparation_note ==
            helper.DisplayPreparationNote.SHOW
        : false;
    },
    preparationDate: function () {
      if (
        !this.selectedService ||
        !this.selectedPeriod ||
        this.is_preparation_note != 1
      ) {
        return null;
      }

      var baseDate =
        this.periodTypeDescriptor == "Day"
          ? this.selectedPeriod
          : this.selectedPeriod.start;
      baseDate = new DateNoTz(baseDate);

      var preparationLeadDays = this.selectedService.preparation_day || 0;
      baseDate.shift(preparationLeadDays * -1); // shift days back

      return baseDate;
    },
    preparationNote() {
      var note;
      if (!this.selectedService) {
        note = null;
      } else {
        note = Texts.render(
          "PREPARATION_NOTE",
          this.periodType,
          {
            selectedServiceGroupName: this.selectedServiceGroupName,
            weekdayFilterStartDesc: this.selectionOptions
              ? this.selectionOptions.weekdayFilterStartDesc
              : null,
            weekdayFilterEndDesc: this.selectionOptions
              ? this.selectionOptions.weekdayFilterEndDesc
              : null,
            preparationDate: this.preparationDate ? this.preparationDate.formatDayParDdMonYyyyPar() : null,
          },
          {
            skipCasing: helper.getPortalName() === `cardinia`,
            sentenceCase : true
          }
        );
      }

      return note;
    },
    
    pickupDate() {
      if (
        !this.selectedService ||
        !this.selectedPeriod ||
        this.is_generate_pickup_date != 1
      ) {
        this.attributes = [];
        return null;
      }

      var baseDate =
        this.periodTypeDescriptor == "Day"
          ? this.selectedPeriod
          : this.selectedPeriod.end;
      baseDate = new DateFormattable(baseDate);

      var endDay = baseDate.getDay();

      var targetDay = -1;
      switch (endDay) {
        case 1:
          targetDay = this.selectedService.mon_pu_date;
          break;
        case 2:
          targetDay = this.selectedService.tue_pu_date;
          break;
        case 3:
          targetDay = this.selectedService.wed_pu_date;
          break;
        case 4:
          targetDay = this.selectedService.thu_pu_date;
          break;
        case 5:
          targetDay = this.selectedService.fri_pu_date;
          break;
      }

      var shiftedDate = new DateNoTz(baseDate);
      shiftedDate.shiftToNextInstanceOfDay(targetDay, true);
      this.attributes = [{
        key: 'pickup',
        highlight: {
            color: 'red',
            fillMode: 'solid'
        },
        dates: new Date(parseInt(shiftedDate.year), parseInt(shiftedDate.month) - 1, parseInt(shiftedDate.day))
      }];
      
      var formattingFunction =
        helper.getPortalName() === `kalamunda`
          ? `formatFullDayDdMonYyyy`
          : `formatDayDdMonYyyy`;

      return shiftedDate[formattingFunction]();
    },

    dateNote() {
      var displayNotes =
        this.selectedService &&
        this.selectedService.date_notes &&
        this.selectedPeriod;
      if (displayNotes) {
        var dateNotes = this.selectedService.date_notes;
        return dateNotes;
      }
    },

    /*
      Stry: P2US413 - one of the bugs
      Date: 2020-11-25
      Auth: Franco Mapua
      Desc: Adding this computed value to check if there are any waste streams enabled that don't have variations selected. 
      This is to keep the user from proceeding with the booking process with a missing variation
    */
    isParentWasteStreamHanging() {
      var selectedBookingProducts =
        this.bookingState &&
        Array.isArray(this.bookingState.selectedBookingProducts)
          ? this.bookingState.selectedBookingProducts
          : [];
      var doesHangingExist = selectedBookingProducts.some(
        /**
        * Stry: RP-109
        * Date: 2021-04-15
        * Auth: Joseph Ricohermoso
        * Desc: To fully validate a parent waste stream without variation selected. Let's use the `hasVariation` prop instead
        * If returns TRUE then the stream is a parent, else either no variation OR the this is the actual variation itself
        */
        (bookingProduct) => bookingProduct.waste_stream_setting_id && bookingProduct.qty == -1
      );
      return doesHangingExist;
    },

    dateFilter: function () {
      var selectedService = this.selectedService;
      var wasteSummary = this.wasteSummary;
      var entitlementSummary = this.entitlementSummary;
      var serverDate = this.serverDate;
      var availableBookingDatesOfAddress = this.availableBookingDatesOfAddress;

      var filter = {
        availableEntitledDates: [],
      };

      if (
        !selectedService ||
        !wasteSummary ||
        !selectedService.service_setting_id ||
        !selectedService.availableBookingDates ||
        !entitlementSummary ||
        availableBookingDatesOfAddress.length == 0 ||
        this.isParentWasteStreamHanging
      ) {
        return filter;
      }

      /* 
        ---- DEV NOTE:
        Most of the filter operations below have been migrated to BookingDatesMixin.js
        If you are to modify or change any of the operations below, please do so in BookingDatesMixin instead
        Then, replacee these outdated filters with function calls to BookingDatesMixins
        - Franco Mapua
      */

      // Filter out dates not availaable
      const removedEmptyAvailableBookings = [];
      availableBookingDatesOfAddress = availableBookingDatesOfAddress.filter(
        (bookingDates) => {
          let availableBookings = bookingDates.availableBookings;
          availableBookings =
            typeof availableBookings === `string`
              ? parseInt(availableBookings)
              : availableBookings;
          if (availableBookings < 1)
            {
            removedEmptyAvailableBookings.push(bookingDates);
            }
          return availableBookings > 0;
        }
      );

      // Calculate For the Available Booking Dates
      var selectedService = new Service(
        selectedService,
        this.serverDateString,
        this.serverDateString
      );

      selectedService.unavailableEmptyBookingDates = removedEmptyAvailableBookings;

      var filteredBookingDates = selectedService.deriveAvailableBookingDates(
        availableBookingDatesOfAddress
      );

      // Remove days before today
      var dateChecker = new DateChecker();
      filteredBookingDates = filteredBookingDates.filter((bookingDate) => {
        return (
          dateChecker.isDateBeforeAnotherDate(bookingDate.date, serverDate) ==
          false
        ); // The booking date must NOT be before the server date
      });

      // Filter by Waste Stream Apis
      var wasteSummary = Array.isArray(this.wasteSummary.selectedWasteStreams) ? this.wasteSummary.selectedWasteStreams : [];
      var filteredSummary = wasteSummary.filter(wasteStream => {
        var id = wasteStream.id || ""
        id = String(id)
        return id.indexOf('fake') == -1
      });
      var wasteStreamApiList = filteredSummary.map(wasteStream => wasteStream.apiValue)
      filteredBookingDates = this.filterBookingDatesByWasteStreamApis(filteredBookingDates, wasteStreamApiList)
      
      if (
        !this.cachedWasteStreamFilters ||
        this.cachedWasteStreamFilters != JSON.stringify(filteredBookingDates)
      ) {
        this.cachedWasteStreamFilters = JSON.stringify(filteredBookingDates);
        this.selectPeriod(null);
        if (this.$refs.residentDatePicker) {
          this.$refs.residentDatePicker.reset();
          this.filterCache = "";
        }
      }

      /*
        Stry: P2US413
        Date: 2020-11-19
        Auth: Franco Mapua
        Desc: Filtering out dates of an entitlement that consums entitlements on collection date
        1. Allow to proceed with booking if there is entitlements for any of the available dates
        2. Disable dates for those dates without entitlement
      */

      // --- Remove Available Entitled Dates according to entitlement usage
      /**
       * Task:    BAUM-697
       * Author:  Joseph Ricohermoso
       * Date:    2021-07-14
       * Desc:    Starting this date, we only filter avail booking dates bound to entitlement period IF
       *          entitlement usage IS NOT "booking date" base. We'll now allow any avail. booking dates
       *          as long as the current entitlement period has balance.
       */
      const entitlementGroupSettings = this.getEntitlementGroup(selectedService.entitlement_setting_id);

      // Task:    BAUM-697 Include entitlement usage type condition
      if (selectedService.entitlement_setting_id && entitlementGroupSettings.entitlement_usage != 2) {
        var effectiveEntitlements = entitlementSummary.effectiveEntitlements;
        var isCurrentEntitled =
          effectiveEntitlements.current[
            selectedService.entitlement_setting_id
          ] > 0;
        var isNextEntitled =
          effectiveEntitlements.next[selectedService.entitlement_setting_id] >
          0;
        var entitlementUsage = this.selectedEntitlementSettings
          ? this.selectedEntitlementSettings.entitlement_usage
          : null;
        var isCollectionDayUsage = entitlementUsage == 1;
        if ((!isCurrentEntitled || !isNextEntitled) && isCollectionDayUsage) {
          filteredBookingDates = filteredBookingDates.filter((entitledDate) => {
            if (
              entitlementSummary.currentPeriod.containsBookingDate(
                entitledDate
              ) &&
              !isCurrentEntitled
            ) {
              return false;
            } else if (
              entitlementSummary.nextPeriod.containsBookingDate(entitledDate) &&
              !isNextEntitled
            ) {
              return false;
            } else {
              return true;
            }
          });
        }
      }

      /**
       * 2021-05-06
       * Author:  Joseph
       * Desc:    Find nearest collection date's product that's currently added in cart
       */
      if (this.selectedService.restrict_single_near_date) {
        const [, recentlyBookedWaste] = selectedService.findAlreadyBookedNearestDate(filteredBookingDates, this.selectedBookingProducts)
        // filteredBookingDates = filteredBookingDatesReturn;

        if (recentlyBookedWaste && recentlyBookedWaste.length) {
          const self = this;

          // Because of updates receieved by this function. This gets called multiple times
          // so we need to debounce the prompt so it only appears once
          if (this.threshold) {
            clearTimeout(this.threshold)
          }

          this.threshold = setTimeout(function() {
            self.$parent.$refs.productSelection.pluckProductFromSelection(recentlyBookedWaste)
            self.$emit(
              "showAlert",
                (
                  self.selectedServiceWording &&
                  self.selectedServiceWording.no_avaiable_dates &&
                  self.selectedServiceWording.no_avaiable_dates != ""
                )
                  ? self.selectedServiceWording.no_avaiable_dates
                  : self.TEXTS.render("WASTE_STREAM_OPTION_NO_BOOKING_DATES")
            );
          }, 0)
        }
      }

      // Derive the dates available for booking for daily/weekly types
      var dateChecker = new DateChecker();
      if (selectedService.entitlement_setting_id == null) {
        // If service is Entitlement-Free
        filteredBookingDates = dateChecker.getAvailableEntitledDates(
          filteredBookingDates,
          selectedService.date_selection
        );
      } else {
        // If service requires entitlements
        filteredBookingDates = dateChecker.getAvailableEntitledDates(
          filteredBookingDates,
          selectedService.date_selection,
          entitlementSummary
        );
      }

      // If Service is weekly ANd has week start and end, remove dates that don't all between the two
      var weekly_start_day = selectedService.weekly_start_day || 1;
      var weekly_end_day = selectedService.weekly_end_day || 5;
      var weeklyStartAndEndEnabled =
        (selectedService.date_selection == "weekly" ||
          selectedService.date_selection == "predefined_week") &&
        (weekly_start_day != 1 || weekly_end_day != 5);
      if (weeklyStartAndEndEnabled) {
        filteredBookingDates = filteredBookingDates.filter((bookingDate) => {
          var weekday = new DateNoTz(bookingDate);
          return (
            weekly_start_day <= weekday.dayNumber &&
            weekday.dayNumber <= weekly_end_day
          );
        });
      }

      // Reset the selection if the service is changed
      if (
        !selectedService ||
        selectedService.service_setting_id != this.selectedServiceId
      ) {
        this.selectedServiceId = selectedService
          ? selectedService.service_setting_id
          : null;
        this.selectPeriod(null);
        if (this.$refs.residentDatePicker) {
          this.$refs.residentDatePicker.reset();
          this.filterCache = "";
        }
      }

      // Assign to Filter
      filter.availableEntitledDates = filteredBookingDates;

      // Predefined Selection -- It will auto select if a predefined selection is made
      if (
        filter.availableEntitledDates &&
        filter.availableEntitledDates.length > 0
      ) {
        var predefinedSelection = null;
        if (this.periodType == "predefined_day") {
          filter.availableEntitledDates = filter.availableEntitledDates.splice(0,1);
          predefinedSelection = filter.availableEntitledDates[0];
        } else if (this.periodType == "predefined_week") {
          var weekly_start_day = this.selectionOptions.weekly_start_day;
          var weekly_end_day = this.selectionOptions.weekly_end_day;
          var daysToSelect = weekly_end_day - weekly_start_day + 1;
          filter.availableEntitledDates = filter.availableEntitledDates.splice(
            0,
            daysToSelect
          );
          predefinedSelection = filter.availableEntitledDates[0];
        } else if (this.periodType == "daily_with_default") {
          predefinedSelection = filter.availableEntitledDates[0];
        }

        // Added condition: this.filterCache !== JSON.stringify(filter)
        // Due to infinite loop deted to this function
        if (
          predefinedSelection &&
          this.filterCache !== JSON.stringify(filter)
        ) {
          this.$refs.residentDatePicker.parseSelectedPeriod(
            filter.availableEntitledDates[0]
          );
        }
      }

      // Set the tooltip message
      this.toolTipMessage =
        filter.availableEntitledDates.length == 0
          ? "Please select a Waste Type"
          : "";

      this.filterCache = JSON.stringify({ ...filter });

      if (!filter.availableEntitledDates.length && this.selectedPeriod) {
        this.selectedPeriod = null;
      }

      return filter;
    },
    hideCollectionWeek() {
      var selectedServiceGroupName = this.selectedServiceGroupName;
      var selectedServiceName = this.selectedServiceName;
      var selectedService = this.selectedService;
      var hidden = false;
      if (
        helper.getPortalName() == "bayswater" &&
        selectedServiceGroupName &&
        selectedServiceGroupName.toLowerCase().indexOf("bin maintenance") >
          -1 &&
        this.periodType == "predefined_day"
      ) {
        hidden = true;
      } else if (
        selectedService &&
        selectedService.display_calendar != helper.DisplayCalendarSetting.SHOW
      ) {
        hidden = true;
      }

      this.$store.dispatch("setIsCollectionWeekShown", !hidden);
      return hidden;
    },
    selectionOptions() {
      var dayNames = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ];
      let weekly_start_day = 1;
      let weekly_end_day = 5;
      if (this.selectedService) {
        weekly_start_day = this.selectedService.weekly_start_day;
        weekly_end_day = this.selectedService.weekly_end_day;
      }
      return {
        weekly_start_day,
        weekly_end_day,
        weekdayFilterStartDesc: dayNames[weekly_start_day],
        weekdayFilterEndDesc: dayNames[weekly_end_day],
      };
    },
    selectedEntitlementSettings() {
      var entitlementSettings;

      var entitlementSummary = this.entitlementSummary;
      var serviceEntitlementId = this.selectedService
        ? this.selectedService.entitlement_setting_id
        : null;

      if (
        entitlementSummary &&
        Array.isArray(entitlementSummary.entitlementSettings) &&
        serviceEntitlementId
      ) {
        entitlementSettings = entitlementSummary.entitlementSettings.find(
          (settings) => settings.entitlement_setting_id == serviceEntitlementId
        );
      }

      return entitlementSettings;
    },
    multipleCollectionCount() {
      return this.bookingState
        ? this.bookingState.multipleCollectionCount
        : null;
    },
    getActiveMultipleServiceSelectedBookingPeriod() {
      if (
        !this.$store.getters.GET_ACTIVE_SERVICE_GROUP ||
        !this.$store.getters.GET_ACTIVE_SERVICE_SETTING
      )
        return null;
      const service_group_id = this.$store.getters.GET_ACTIVE_SERVICE_GROUP
        .service_group_id;
      const service_setting_id = this.$store.getters.GET_ACTIVE_SERVICE_SETTING
        .service_setting_id;

      return this.$store.getters.GET_ACTIVE_MULTIPLE_SERVICE_SELECTED_BOOKING_DATES.find(
        (period) =>
          period.service_group_id === service_group_id &&
          period.service_setting_id === service_setting_id
      );
    },
    selectedBookingProducts() {
      return !this.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED ?
        this.bookingState.selectedBookingProducts
        : this.$store.getters.GET_ACTIVE_MULTIPLE_SERVICE_SELECTED_BOOKING_PRODUCTS;
    },
    selectedServiceDeliveryMessage() {
      if (this.selectedServiceWording && this.selectedServiceWording.service_wordings_delivery_message) {
        return this.selectedServiceWording.service_wordings_delivery_message;
      }

      return Texts.render(
        `COLLECTION_WEEK_PERIOD_SELECTED`,
        this.selectedServiceNameCondensed,
        { periodTypeDescriptor: this.periodTypeDescriptor }
      )
    },
    pickupMessage() {
      if (this.selectedServiceWording && this.selectedServiceWording.service_wordings_pickup_message)
        return this.selectedServiceWording.service_wordings_pickup_message;
      
      return Texts.render(
        `COLLECTION_WEEK_PICKUP_DATE`,
        this.selectedServiceNameCondensed
      )
    }
  },
  methods: {
    selectPeriod: function (val) {
      this.selectedPeriod = val;

      if (this.bookingState) {
        var bookingState = this.bookingState;

        if (val) {
          // --- Intercept this to check if there are enough entitlements for a CollectionDate-mode Entitlement
          var multipleCollectionValue = this.multipleCollectionCount;
          var selectedEntitlementSettings = this.selectedEntitlementSettings;
          var entitlementId = selectedEntitlementSettings
            ? selectedEntitlementSettings.entitlement_setting_id
            : null; // --- Patched a null pointer error for DEF_RP2_TEST2 - Franco Mapua
          var entitlementSummary = this.entitlementSummary;

          if (
            selectedEntitlementSettings &&
            entitlementSummary &&
            selectedEntitlementSettings.entitlement_usage == "1"
          ) {
            var entitlementsAvailable;

            var currentStart = new DateNoTz(
              entitlementSummary.currentPeriod.startDate
            );
            var currentEnd = new DateNoTz(
              entitlementSummary.currentPeriod.endDate
            );
            if (val.start && val.end) {
              // --- weekly
              var selectionStart = new DateNoTz(val.start);
              var selectionEnd = new DateNoTz(val.end);
              if (
                currentStart.convertToSeconds() <=
                  selectionStart.convertToSeconds() &&
                selectionEnd.convertToSeconds() <= currentEnd.convertToSeconds()
              ) {
                entitlementsAvailable =
                  entitlementSummary.currentPeriod.entitlementsRemaining[
                    entitlementId
                  ];
              } else if (entitlementSummary.nextPeriod) {
                entitlementsAvailable =
                  entitlementSummary.nextPeriod.entitlementsRemaining[
                    entitlementId
                  ];
              }
            } else {
              // --- daily
              var selectedDate = new DateNoTz(val); // --- TODO BUG HERE
              if (
                currentStart.convertToSeconds() <=
                  selectedDate.convertToSeconds() &&
                selectedDate.convertToSeconds() <= currentEnd.convertToSeconds()
              ) {
                entitlementsAvailable =
                  entitlementSummary.currentPeriod.entitlementsRemaining[
                    entitlementId
                  ];
              } else if (entitlementSummary.nextPeriod) {
                entitlementsAvailable =
                  entitlementSummary.nextPeriod.entitlementsRemaining[
                    entitlementId
                  ];
              }
            }

            // -- Compare entitlementsAvailable to what's currently selected
            if (
              entitlementsAvailable &&
              multipleCollectionValue > entitlementsAvailable
            ) {
              var self = this;
              this.$emit(
                "collectionWeekAlert",
                Texts.render(`COLLECTION_WEEK_NOT_ENOUGH_ENTITLEMENTS`, null, {
                  numberOfCollections: entitlementsAvailable,
                }),
                function () {
                  self.$emit("setMultipleCollection", entitlementsAvailable);
                  self.updateBookingState(val);
                },
                function () {
                  self.$refs.residentDatePicker.reset();
                  this.filterCache = "";
                }
              );
              return;
            }
          }
        }
        this.updateBookingState(val);
      }
    },
    updateBookingState(val) {
      var bookingState = this.bookingState;
      // --- Commit the change to the
      var willCommitChange = false;
      var checker = new DateChecker();
      // Case One: Val is undefined and collection data is defined
      if (
        !val &&
        bookingState.collectionData &&
        bookingState.collectionData.selectedPeriod
      ) {
        willCommitChange = true;
      }
      // Case Two val is defined and collection data is undefined
      else if (
        (!bookingState.collectionData ||
          !bookingState.collectionData.selectedPeriod) &&
        val
      ) {
        willCommitChange = true;
      }
      // Case Three: val and collection data or defined and are not the same
      else if (
        bookingState.collectionData &&
        !checker.arePeriodsTheSame(
          bookingState.collectionData.selectedPeriod,
          val
        )
      ) {
        willCommitChange = true;
      }

      if (willCommitChange) {
        bookingState.collectionData = {
          periodType: this.periodType,
          selectedPeriod: this.selectedPeriod,
          preparationDate: this.preparationDate ? this.preparationDate.formatFullDayDdMonYyyy() : null,
          pickupDate: this.pickupDate,
        };
        this.$store.dispatch("setBookingState", bookingState);
        this.$store.dispatch("setActiveMultipleServiceSelectedBookingPeriods", {
          selectedPeriod: this.selectedPeriod,
          preparationDate: this.preparationDate ? this.preparationDate.formatFullDayDdMonYyyy() : null,
          pickupDate: this.pickupDate,
        });
      }
    },
    getEntitlementGroup(entitlementSettingId) {
      const entitlementGroupSettings  = this.$store.getters.GET_ENTITLEMENT_GROUP.list;
      return (!Array.isArray(entitlementGroupSettings)) ? null : entitlementGroupSettings.find(settings => settings.entitlement_setting_id == entitlementSettingId);
    },
  },
  watch: {
    getActiveMultipleServiceSelectedBookingPeriod: function (found) {
      this.hasActiveMultipleServiceSelectedBookingPeriod = false;
      if (
        !this.$store.getters.GET_ACTIVE_SERVICE_GROUP ||
        !this.$store.getters.GET_ACTIVE_SERVICE_SETTING
      )
        return;

      if (found && !this.hasActiveMultipleServiceSelectedBookingPeriod) {
        this.hasActiveMultipleServiceSelectedBookingPeriod = true;
      }
      if (!found && this.hasActiveMultipleServiceSelectedBookingPeriod) {
        // Multiple service booking period emptied. Clear the visible calendar selection
        this.selectPeriod(null);
        if (this.$refs.residentDatePicker) {
          this.$refs.residentDatePicker.reset();
          this.filterCache = "";
        }
      }
    },
    pickupDate: function (pick) {
      if (pick) {
        this.$store.dispatch("setActiveMultipleServiceSelectedBookingPeriods", {
          selectedPeriod: this.selectedPeriod,
          pickupDate: pick,
        });
      }
    },
  },
};
</script>